import { type ConversationResolveInput, type ConversationResolveSuccess } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { useTantalimMutation, type TantalimMutationResponse } from '../mutation'
import { conversationsInfiniteKey, conversationsKey } from './keys'

export function useResolveConversation(): TantalimMutationResponse<
  ConversationResolveInput,
  ConversationResolveSuccess
> {
  const queryClient = useQueryClient()
  return useTantalimMutation<ConversationResolveInput, ConversationResolveSuccess>({
    url: '/conversation/resolve',
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: conversationsInfiniteKey().slice(0, 1) })
      void queryClient.invalidateQueries({ queryKey: conversationsKey() })
      void queryClient.invalidateQueries({ queryKey: ['conversation'] })
    },
  })
}
